module.exports = __webpack_public_path__ + "img/about_logo_22.6f2e4a5f.png";